const baseUrl = "Webhook";

export const tiggerRemitaPaymentUrl = (rrr) => `${baseUrl}/remitapayment?rrr=${rrr}`;
export const verifyRemitaStatus =(rrr)=>`${baseUrl}/remita-status?RRR=${rrr}`
